import { Controller } from "@hotwired/stimulus"

/**
 * Per-class targeting for teacher stories:
 * - When a classroom is checked, show targeting options
 * - For each classroom: "All parents" or "Specific students"
 * - Students are loaded via fetch when "specific" is selected
 */
export default class extends Controller {
  static values = {
    studentsUrl: String,
    storyId: String,
  }

  classroomToggled(event) {
    const checkbox = event.target
    const item = checkbox.closest("[data-classroom-id]")
    const panel = item.querySelector("[data-targeting-options]")

    if (checkbox.checked) {
      panel.classList.remove("hidden")
    } else {
      panel.classList.add("hidden")
      this.#hideStudents(item)
      this.#clearStudents(item)
      this.#resetToAll(item)
    }
  }

  modeChanged(event) {
    const radio = event.target
    const item = radio.closest("[data-classroom-id]")
    const classroomId = item.dataset.classroomId

    if (radio.value === "specific") {
      this.#showStudents(item, classroomId)
    } else {
      this.#hideStudents(item)
      this.#clearStudents(item)
    }
  }

  #showStudents(item, classroomId) {
    const container = item.querySelector(
      "[data-students-container]"
    )
    container.classList.remove("hidden")

    if (!container.dataset.loaded) {
      this.#loadStudents(container, classroomId)
    }
  }

  #hideStudents(item) {
    const container = item.querySelector(
      "[data-students-container]"
    )
    if (container) container.classList.add("hidden")
  }

  #clearStudents(item) {
    item
      .querySelectorAll("input[name='story[student_ids][]']")
      .forEach((cb) => {
        cb.checked = false
      })
  }

  #resetToAll(item) {
    const allRadio = item.querySelector("input[value='all']")
    if (allRadio) allRadio.checked = true
  }

  async #loadStudents(container, classroomId) {
    const url = new URL(
      this.studentsUrlValue,
      window.location.origin
    )
    url.searchParams.set("classroom_id", classroomId)
    if (this.storyIdValue) {
      url.searchParams.set("story_id", this.storyIdValue)
    }

    container.innerHTML =
      '<div class="text-center py-4">' +
      '<span class="text-sm text-gray-400">...</span></div>'

    try {
      const response = await fetch(url, {
        headers: {
          Accept: "text/html",
          "X-Requested-With": "XMLHttpRequest",
        },
      })
      if (response.ok) {
        container.innerHTML = await response.text()
        container.dataset.loaded = "true"
      }
    } catch {
      container.innerHTML =
        '<div class="text-center py-4 text-red-500 text-sm">' +
        "Erreur</div>"
    }
  }
}
